// src/components/Footer.js
import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="shared-footer">
      <div className="footer-content">
        <p>&copy; 2026 Citadel Strategic Ventures. All Rights Reserved.</p>
        <p className="sub-footer">
          Citadel Strategic Ventures is not affiliated with Citadel, LLC.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
